import React, {useEffect, useState} from "react";
import {Box, Button, Card, CardContent, TextField, Tooltip, Typography} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ApiService from "../services/ApiService";

export default function CardCart({item, orderInitial, changeOrderInitial, alertDeleteItemFromOrder}) {
    const [stock, setStock] = useState(0);
    const [order, setOrder] = useState(orderInitial);

    useEffect(() => {
        fetchStocks(item.product.id);
    }, [item]);

    function deleteItem(itemId) {
        ApiService.deleteOrderItemByIds(order.id, itemId).then(response => response.json()).then(response => {
            if (response) {
                setOrder(response);
                changeOrderInitial(response);
                alertDeleteItemFromOrder(true);
            }
        })
    }

    function fetchStocks(id) {
        ApiService.getStockQuantityByProductId(id).then(response => response.json()).then(response => {
            const quantity = response.availableQuantity;
            setStock(quantity);
        })
    }

    function handleChange(itemId, event) {
        const value = Number(event);
        if (value <= 0) {
            deleteItem(itemId)
        } else {
            const body = {
                id: itemId,
                quantity: event,
                orderId: order.id
            };
            ApiService.updateOrderItem(body).then(response => response.json()).then(response => {
                if (response) {
                    setOrder(response);
                    changeOrderInitial(response);
                }
            });
        }
    }

    function getDescriptionRoundCircle() {
        let circleColor = 'orange';
        let setTitle = 'Disponibilità limitata';

        if (stock > item.product.minimumStockQuantity) {
            setTitle = 'Disponibile';
            circleColor = 'green';
        } else if ((stock <= 0 && item.product.minimumStockQuantity >= 0)) {
            setTitle = 'Non disponibile';
            circleColor = 'red';
        } else {
        }

        return <Tooltip title={setTitle} placement="top">
            {circleColor === 'green' ?
                <CircleIcon sx={{
                    color: (theme) => theme.palette.success.main,
                    width: '16px',
                    height: '16px'
                }}/>
                :
                <CircleIcon sx={{
                    color: (theme) => circleColor === 'red' ? theme.palette.error.main : theme.palette.warning.main,
                    width: '16px',
                    height: '16px'
                }}/>}
        </Tooltip>;
    }

    function totalFormatted() {
        return (item.price * item.quantity / 100).toFixed(2) + ' CHF';
    }

    return (
        <>
            <Card key={item.id}
                  variant="outlined"
                  sx={{
                      borderRadius: 0,
                      border: 'none',
                      borderBottom: '1px solid rgba(0, 0, 0, 0.46)',
                  }}
            >
                <CardContent
                    sx={{
                        p: 1.5,
                        pb: '10px!important'
                    }}
                >
                    <Box
                        sx={{
                            display: 'grid',
                            width: '100%',
                            columnGap: 1,
                            rowGap: 1,
                            gridTemplateColumns: {
                                xs: '1fr 1fr 1fr 1fr 1fr',
                                md: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr'
                            },
                            gridTemplateRows: {
                                xs: 'auto',
                                md: 'auto'
                            },
                            gridTemplateAreas: {
                                xs: `
                            'code code code availability availability'
                            'title title title title title'
                            'price input total total delete'
                            `,
                                md: `
                            'code title title title title availability price unit input total total delete' 
                            `,
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'code',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography color="textSecondary" sx={{fontSize: '0.875rem'}}> <Typography
                                component={'span'}
                                sx={{display: {md: 'none'}}}>Cod.</Typography> {item.product.code}</Typography>
                        </Box>

                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'availability',
                                display: 'flex',
                                justifyContent: {
                                    xs: 'flex-end',
                                    md: 'flex-start'
                                },
                                alignItems: 'center'
                            }}
                        >
                            {getDescriptionRoundCircle()}
                        </Box>

                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'title',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography sx={{fontSize: {md: '0.875rem'}}}>
                                {item.product.name}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'price',
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <Typography sx={{fontSize: '0.875rem'}}>{item.priceFormatted} CHF</Typography>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'input',
                            }}
                        >
                            <TextField
                                type="number"
                                defaultValue={item.quantity}
                                id="quantity}"
                                onChange={(event) => handleChange(item.id, event.target.value)}
                                variant={'standard'}
                                sx={{
                                    width: '60px'
                                }}
                            >
                            </TextField>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'unit',
                                display: {
                                    xs: 'none',
                                    md: 'inline-flex'
                                },
                                alignItems: 'center'
                            }}
                        >
                            <Typography sx={{fontSize: '0.875rem'}}>{item.product.unitDescription}</Typography>
                        </Box>

                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'total',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center'
                            }}
                        >
                            <Typography sx={{fontSize: '0.875rem'}}><Typography component={'span'}
                                                                                sx={{display: {md: 'none'}}}>Tot.:</Typography>{totalFormatted()}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                width: '100%',
                                gridArea: 'delete',
                                display: 'flex',
                                justifyContent: 'flex-end',
                                alignItems: 'center'
                            }}
                        >
                            <Button color={'error'}
                                    sx={{
                                        minWidth: 'initial',
                                        p: 0
                                    }}
                                    onClick={() => deleteItem(item.id)}
                            >
                                <DeleteOutlineIcon/>
                            </Button>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </>
    )
}